import React from 'react';
import { TrendingUp, Ship, Award, CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../mockData';

const Services = () => {
  const serviceDetails = [
    {
      id: 1,
      icon: TrendingUp,
      title: "Bauxite Trading & Brokerage",
      description: "Direct sourcing of premium-grade bauxite from Guinea with reliable supply chains to Asia, Middle East, and Europe.",
      details: [
        "Direct partnerships with Guinea mining operations",
        "Flexible contract terms (spot and long-term)",
        "Competitive pricing with transparent cost structure",
        "Multiple grade options to meet specific requirements",
        "Quality certificates and documentation"
      ],
      benefits: [
        "Reliable supply continuity",
        "Quality consistency",
        "Cost optimization",
        "Risk mitigation"
      ]
    },
    {
      id: 2,
      icon: Ship,
      title: "Supply Chain Management",
      description: "End-to-end logistics coordination from mine to port, ensuring timely delivery and quality maintenance.",
      details: [
        "Mine-to-port coordination in Guinea",
        "International shipping arrangements",
        "Port handling and storage management",
        "Customs clearance and documentation",
        "Real-time shipment tracking"
      ],
      benefits: [
        "Reduced delivery time",
        "Lower logistics costs",
        "Full transparency",
        "Reduced complexity"
      ]
    },
    {
      id: 3,
      icon: Award,
      title: "Quality Consulting",
      description: "Expert analysis and consulting on bauxite quality, specifications, and market conditions.",
      details: [
        "Laboratory testing and analysis",
        "Grade specification consulting",
        "Market intelligence reports",
        "Technical advisory services",
        "Compliance and regulatory guidance"
      ],
      benefits: [
        "Informed decisions",
        "Risk reduction",
        "Market advantage",
        "Regulatory compliance"
      ]
    }
  ];

  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="page-hero">
        <h1 className="display-huge">Our Services</h1>
        <p className="body-large hero-description">
          Comprehensive bauxite trading solutions from sourcing to delivery
        </p>
      </section>

      {/* Services Detail */}
      {serviceDetails.map((service, index) => {
        const IconComponent = service.icon;
        return (
          <section key={service.id} className={`service-detail-section ${index % 2 === 1 ? 'alt' : ''}`}>
            <div className="service-detail-content">
              <div className="service-detail-header">
                <div className="service-detail-icon">
                  <IconComponent size={40} />
                </div>
                <div>
                  <h2 className="display-medium">{service.title}</h2>
                  <p className="body-large">{service.description}</p>
                </div>
              </div>

              <div className="service-detail-grid">
                <div className="service-detail-box">
                  <h3 className="heading-2">What We Offer</h3>
                  <ul className="service-list">
                    {service.details.map((detail, idx) => (
                      <li key={idx} className="body-medium">
                        <CheckCircle size={20} />
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="service-detail-box">
                  <h3 className="heading-2">Key Benefits</h3>
                  <ul className="benefit-list">
                    {service.benefits.map((benefit, idx) => (
                      <li key={idx} className="benefit-item">
                        <div className="benefit-badge"></div>
                        <span className="body-medium">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </section>
        );
      })}

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="display-large">Ready to Get Started?</h2>
          <p className="body-large">
            Contact our team to discuss your bauxite requirements and receive a tailored solution.
          </p>
          <Link to="/contact" className="btn-primary">
            Request a Quote
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;